import {Injectable, Injector} from "@angular/core";
import {AccountTypeData} from "./account-type.data";
import {EntityModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class AccountTypeEntityModel extends EntityModel<AccountTypeData> {

    constructor(injector: Injector) {
        super(injector, AccountTypeData);
    }

    protected override onNewEntity(entityData: AccountTypeData): void {
        super.onNewEntity(entityData);
        entityData.validBillingCycles = [AccountTypeData.BILLING_CYCLE_NONE];
        entityData.defaultBillingCycleDbValue = AccountTypeData.BILLING_CYCLE_NONE;
    }
}
